(() => {
  'use strict';

  const root = document.querySelector('.uth-commerce--visual-v2, .uth-commerce-product--visual-v2');
  if (!root) return;

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const coarsePointer = window.matchMedia('(pointer: coarse)');
  const html = document.documentElement;

  html.classList.add('uth-v2-ready');

  const revealNodes = Array.from(root.querySelectorAll('.uth-v2-reveal'));
  if (motionQuery.matches || !('IntersectionObserver' in window)) {
    revealNodes.forEach((node) => node.classList.add('is-v2-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-v2-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    revealNodes.forEach((node) => revealObserver.observe(node));
  }

  const stepNodes = Array.from(root.querySelectorAll('[data-v2-step]'));
  if (stepNodes.length && 'IntersectionObserver' in window) {
    const stepObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-v2-active', entry.isIntersecting && entry.intersectionRatio >= 0.48);
      });
    }, { threshold: [0.2, 0.48, 0.75] });

    stepNodes.forEach((node) => stepObserver.observe(node));
  }

  const theater = root.querySelector('[data-v2-parallax]');
  if (theater && !motionQuery.matches && !coarsePointer.matches) {
    let frame = 0;
    const update = (event) => {
      const rect = theater.getBoundingClientRect();
      const normalizedX = ((event.clientX - rect.left) / Math.max(rect.width, 1)) - 0.5;
      const normalizedY = ((event.clientY - rect.top) / Math.max(rect.height, 1)) - 0.5;
      const x = Math.max(-4, Math.min(4, normalizedX * 8));
      const y = Math.max(-4, Math.min(4, normalizedY * 8));

      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        root.style.setProperty('--v2-parallax-x', `${x.toFixed(2)}px`);
        root.style.setProperty('--v2-parallax-y', `${y.toFixed(2)}px`);
      });
    };

    theater.addEventListener('pointermove', update, { passive: true });
    theater.addEventListener('pointerleave', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        root.style.setProperty('--v2-parallax-x', '0px');
        root.style.setProperty('--v2-parallax-y', '0px');
      });
    }, { passive: true });
  }

  document.addEventListener('visibilitychange', () => {
    html.classList.toggle('uth-v2-paused', document.hidden);
  });

  const gallery = root.querySelector('[data-uth-commerce-gallery]');
  if (gallery) {
    gallery.addEventListener('click', (event) => {
      const button = event.target.closest('[data-uth-commerce-thumb]');
      if (!button) return;
      root.classList.add('is-v2-gallery-changing');
      window.setTimeout(() => root.classList.remove('is-v2-gallery-changing'), 420);
    });
  }

  const fitButtons = root.querySelectorAll('.uth-v2-fit-verdict [data-uth-nia-fit]');
  fitButtons.forEach((button) => {
    button.addEventListener('pointerenter', () => root.classList.add('is-v2-fit-ready'), { passive: true });
    button.addEventListener('pointerleave', () => root.classList.remove('is-v2-fit-ready'), { passive: true });
  });
})();
